module.exports = __webpack_public_path__ + "img/icon_swipe_left.8091d48c.png";